export enum API_TYPES {
  AWARDS_API_URI = 'AWARDS_API_URI',
}

const developmentApi: Record<API_TYPES, string> = {
  AWARDS_API_URI: 'https://mt-api.dev.mos.coke.com/v2/networked-awards',
}

const productionApi: Record<API_TYPES, string> = {
  AWARDS_API_URI: 'AWARDS_API_URI',
}

const config = Object.keys(API_TYPES).reduce(
  (acc, type) => {
    const api =
      process.env.NODE_ENV !== 'development'
        ? process.env[`REACT_APP_${type}`] || productionApi[type as API_TYPES]
        : developmentApi[type as API_TYPES]
    return { ...acc, [type]: api }
  },
  {} as Record<API_TYPES, string>,
)

export default config
